import { newProperty } from "../schema.generator";

const newLayerSchema = [
  { ...newProperty("name", "string", true, "Name") }
];

export default newLayerSchema;
